module.exports = __webpack_public_path__ + "img/logo_yyw_w@2x.b40dad60.png";